import { Injectable, Optional } from '@angular/core';
import { Observable, of, from, EMPTY } from 'rxjs';
import { every, concatMap, switchMap, take, tap } from 'rxjs/operators';
import { AppOptions } from '@gsp-sys/rtf-common';
import { RuntimeFrameworkService } from './rtf-service';
import { MenuStateService } from './menu-state.service';
import { TAB_EVENT } from './types';
import { QuerystringService } from './querystring';
import { FrameContext, UID } from '@farris/devkit';
import { ChangeItemService } from './change-item.service';

/**
 * å¯¼èªäºä»¶æå¡
 * @scope FormModule
 */
@Injectable()
export class NavigationEventService {
  public frameContext: FrameContext;
  /**
   * å³é­åäºä»¶å¤çå¨
   */
  private onClosedListeners: Map<string, (options?: AppOptions) => void>;
  /**
   * å³é­åå¤çå¨
   */
  private onClosingListeners: Map<string, (options?: AppOptions) => Observable<boolean>>;
  private onTabSwitchListeners: Map<string, (options?: AppOptions) => void>;
  private params: { [propName: string]: any; };

  constructor(
    private runtimeFrameworkService: RuntimeFrameworkService,
    private menuStateService: MenuStateService,
    private querystringService: QuerystringService
  ) {
    this.onClosedListeners = new Map<string, (options?: AppOptions) => void>();
    this.onClosingListeners = new Map<string, (options?: AppOptions) => Observable<boolean>>();
    this.onTabSwitchListeners = new Map<string, (options?: AppOptions) => void>();
  }
  private get querystrings() {
    const params = this.querystringService.parse(window.location.hash);
    // ä¿®æ­£formToken
    if (params) {
      params.formToken = this.runtimeFrameworkService.formToken;
    }
    return params;
  }
  /**
   * æ³¨åäºä»¶
   */
  public registerEvent() {
    const options = this.querystrings;
    this.params = options;
    // æ³¨åæ ç­¾é¡µåæ¢äºä»¶
    this.runtimeFrameworkService.addEventListener(TAB_EVENT.onTabSwitched, (e) => this.handleTabSwitchEvent(e), options);
    // æ³¨åæ ç­¾é¡µå³é­åäºä»¶
    this.runtimeFrameworkService.addEventListener(TAB_EVENT.onTabClosed, (e) => this.handleTabClosedEvent(e), options);
    // æ³¨åæ ç­¾é¡µå³é­åäºä»¶
    this.runtimeFrameworkService.addEventListener(TAB_EVENT.onTabClosing, (e) => this.handleTabClosingEvent(e), options);
  }
  /**
   * å¤çæ ç­¾é¡µåæ¢äºä»¶
   */
  private handleTabSwitchEvent(e: any) {
    if (!e) {
      return;
    }
    // éä¸­çè¡¨åä¸ºç³»ç»è¡¨åï¼åªè½è¿åidï¼æ²¡ætabId
    const eventTabId = e.tabId || e.id || null;
    if (!eventTabId) {
      return;
    }
    const options = this.params; // this.querystrings;
    const tabId = options.tabId || options.funcId || options.appId;
    const menuState = this.menuStateService.getMenuState(eventTabId);
    if (!!tabId && tabId === eventTabId && !!menuState && menuState.length > 0) {
      this.formReload();
    }
    this.fireTabSwitchEvent(e);
  }
  /**
   * è§¦åtabåæ¢äºä»¶
   * @param e e
   */
  private fireTabSwitchEvent(e: any) {
    if (!this.onTabSwitchListeners || this.onTabSwitchListeners.size < 1) {
      return;
    }
    this.onTabSwitchListeners.forEach((handle, key, map) => {
      if (typeof handle === 'function') {
        handle(e);
      }
    });
  }
  /**
   * æ ç­¾é¡µå³é­åäºä»¶
   */
  private handleTabClosingEvent(e: any) {
    if (!e) {
      return;
    }
    // è¦å³é­çè¡¨åä¸ºç³»ç»è¡¨åï¼åªè½è¿åidï¼æ²¡ætabId
    const eventTabId = e.tabId || e.id || null;
    const options = this.params; // this.querystrings;
    const tabId = options.tabId || options.funcId || options.appId;
    if (!!eventTabId && !!tabId && tabId === eventTabId) {
      this.fireTabClosingEvent(e).subscribe((result) => {
        if (result) {
          setTimeout(() => this.removeMenuState(eventTabId), 500);
          const formEventServices: Map<string, any> = window['formEventServices'];
          if (formEventServices.has(eventTabId)) {
            formEventServices.delete(eventTabId);
            window['formEventServices'] = formEventServices;
          }
          if (!(e && e.hasOwnProperty('token'))) {
            e = Object.assign({}, e, { token: options.formToken });
          }
          // TODO:ä¸åä¸»å¨éæ¯appContextï¼å¯è½å­å¨åå­æ³æ¼é®é¢
          // if (this.frameContext && this.frameContext.appContext) {
          //   this.frameContext.appContext.dispose();
          // }
          ChangeItemService.dispose(tabId);
          this.runtimeFrameworkService.closeMenu(e);
        }
      });
    }
  }
  /**
   * è§¦åå³é­åäºä»¶
   */
  private fireTabClosingEvent(e: any): Observable<boolean> {
    if (!this.onClosingListeners || this.onClosingListeners.size < 1) {
      return of(true);
    }
    const listeners = this.onClosingListeners.values();
    const result$ = from(listeners);
    // ç¨æ·æç»
    let userRejected = false;
    return result$.pipe(
      concatMap((handle) => {
        if (userRejected) {
          return EMPTY;
        }
        return handle(e).pipe(
          take(1),
          tap((result) => userRejected = !result),
          switchMap((result) => of(result))
        );
      }),
      every((result) => result)
    );
  }
  /**
   * æ ç­¾é¡µå³é­åäºä»¶
   */
  private handleTabClosedEvent(e: any) {
    if (!e) {
      return;
    }
    const options = this.params; // this.querystrings;
    const tabId = options.tabId || options.funcId || options.appId;
    const eventTabId = e.tabId || e.id || null;
    if (tabId === eventTabId) {
      return;
    }
    const menuState = this.menuStateService.getMenuState(tabId, eventTabId);
    if (!!eventTabId && !!menuState && menuState.length > 0) {
      this.removeMenuState(eventTabId);
      this.formReload();
    }
    this.fireTabClosedEvent(e);
  }
  private removeMenuState(tabId: string) {
    if (this['context']) {
      this.menuStateService.removeMenu(tabId);
    }
  }
  /**
   * è§¦åå³é­åäºä»¶
   * @param e event
   */
  private fireTabClosedEvent(e: any) {
    if (!this.onClosedListeners || this.onClosedListeners.size < 1) {
      return;
    }
    this.onClosedListeners.forEach((handle, key, map) => {
      if (typeof handle === 'function') {
        handle(e);
      }
    });
  }
  // #endregion
  /**
   * æ³¨åäºä»¶çå¬å¨
   * @param eventType äºä»¶ç±»å onTabClosed
   * @param handler å¤çå¨
   */
  public addEventListener(eventType: string, handler: (options: AppOptions) => any): string {
    const key = UID.create();
    if (eventType === TAB_EVENT.onTabClosed) {
      this.onClosedListeners.set(key, handler);
      return key;
    } else if (eventType === TAB_EVENT.onTabClosing) {
      this.onClosingListeners.set(key, handler);
      return key;
    } else if (eventType === TAB_EVENT.onTabSwitched) {
      this.onTabSwitchListeners.set(key, handler);
      return key;
    }
    return null;
  }
  /**
   * ç§»é¤äºä»¶çå¬å¨
   * @param eventType äºä»¶ç±»å
   * @param key äºä»¶æ è¯
   */
  public removeEventListener(eventType: string, key: string) {
    if (eventType === TAB_EVENT.onTabClosed) {
      return this.onClosedListeners.delete(key);
    } else if (eventType === TAB_EVENT.onTabClosing) {
      return this.onClosingListeners.delete(key);
    }
    return false;
  }
  /**
   * æ¸ç©ºäºä»¶çå¬å¨
   * @param eventType äºä»¶ç±»å
   */
  public clearEventListener(eventType: string): void {
    if (eventType === TAB_EVENT.onTabClosed) {
      this.onClosedListeners.clear();
    } else if (eventType === TAB_EVENT.onTabClosing) {
      this.onClosingListeners.clear();
    }
  }
  /**
   * å·æ°ç»ä»¶æ°æ®
   */
  private formReload() {
    try {
      // tslint:disable-next-line: no-string-literal
      this['context']['frameContext']['appContext']['refresh']();
    } catch { }
  }
}
